var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWithdraw = function SvgWithdraw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18718 9.64787C6.71863 10.0872 6.71942 10.7967 7.19273 11.2364L11.2414 14.9975C12.3614 16.0663 14.042 14.4627 12.9219 13.3938L11.5535 12.0926C11.2418 11.7962 11.3475 11.5563 11.784 11.5563L17.2323 11.5563C17.8874 11.5563 18.4178 11.0472 18.4178 10.4222C18.4178 9.79645 17.8839 9.28855 17.2323 9.28855L11.784 9.28855C11.3451 9.28855 11.2418 9.04825 11.5535 8.75223L12.9219 7.4514C14.042 6.38216 12.3614 4.77887 11.2414 5.84773L7.18718 9.64787ZM18.5939 3.05307C14.3405 -1.01769 7.44375 -1.01769 3.19035 3.05307C-1.06345 7.12346 -1.06345 13.7231 3.19035 17.7935C7.44375 21.8642 14.3405 21.8642 18.5939 17.7935C19.1354 17.2757 19.1354 16.4354 18.5939 15.9177C18.0525 15.3995 17.1748 15.3995 16.6334 15.9177C13.4624 18.9518 8.32144 18.9518 5.1505 15.9177C1.97996 12.8832 1.97996 7.96338 5.1505 4.92888C8.32144 1.89476 13.4624 1.89476 16.6334 4.92888C17.1748 5.44702 18.0525 5.44702 18.5939 4.92888C19.1354 4.41113 19.1354 3.57121 18.5939 3.05307Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWithdraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/withdraw.77f44678.svg";
export { ForwardRef as ReactComponent };